<script setup lang="ts">
import Polygon from '../../icons/polygon.svg';
import { onMounted, ref } from 'vue';

export interface TooltipProps {
  text?: string;
  toRight?: boolean;
}

const props = defineProps<TooltipProps>();

const slotRef = ref<HTMLElement | null>(null);
const tooltipRef = ref();

const setTooltipPosition = () => {
  if (slotRef.value && tooltipRef.value) {
    const slotWidth = slotRef.value.offsetWidth;
    const height = slotRef.value.offsetHeight;
    if (props.toRight) {
      tooltipRef.value.style.left = `${slotWidth / 2}px`;
    } else {
      tooltipRef.value.style.right = `${slotWidth / 2}px`;
    }

    tooltipRef.value.style.bottom = `${height + 8}px`;
  }
};

onMounted(() => {
  setTooltipPosition();
});
</script>

<template>
  <div class="tooltip-container" :class="{ 'to-right': props.toRight }">
    <div class="slot" ref="slotRef">
      <slot />
    </div>
    <div class="tooltip" ref="tooltipRef">
      <p>{{ text }}</p>
      <Polygon />
    </div>
  </div>
</template>

<style scoped>
.tooltip-container {
  position: relative;
  width: fit-content;

  & .slot {
    cursor: pointer;
    display: flex;
  }

  .tooltip {
    opacity: 0;
    visibility: hidden;
    max-width: 350px;
    transition: all 250ms;
    transition-delay: 0.5s;
    right: 6px;
    z-index: 10;
    position: absolute;
    background-color: #79859e;
    width: max-content;
    padding: 8px 16px;
    border-radius: 8px 8px 0 8px;

    & p {
      color: white;
      margin: 0;
      font: var(--font-body-m);
    }

    & svg {
      position: absolute;
      right: 0;
      bottom: -4px;
    }
  }
}

.to-right {
  .tooltip {
    left: 6px;
    border-radius: 8px 8px 8px 0;

    & svg {
      transform: rotateY(180deg);
      left: 0;
    }
  }
}

.tooltip-container:has(.slot:hover) {
  .tooltip {
    opacity: 1;
    visibility: visible;
  }
}
</style>
